import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import BottomNavigationCustomer from "./BottomNavigatonCustomer";
import CurrentOrdersList from "../VendorResponsesCustomer/CurrentOrdersList";

const config = {
  cUrl: "https://api.countrystatecity.in/v1/countries/IN",
  ckey: "NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA==",
};

const UserProfileSection = () => {
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  console.log('user', userId)

  useEffect(() => {
    loadStates();
  }, []);

  const loadStates = () => {
    setIsLoadingStates(true);
    fetch(`${config.cUrl}/states`, {
      headers: { "X-CSCAPI-KEY": config.ckey },
    })
      .then((response) => response.json())
      .then((data) => {
        setStates(data);
        setFilteredStates(data);
        setIsLoadingStates(false);
      })
      .catch((error) => {
        console.error("Error loading states:", error);
        setIsLoadingStates(false);
      });
  };

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setSearchTerm(val);
    setFilteredStates(
      states.filter((state) =>
        state.name.toLowerCase().includes(val)
      )
    );
  };

  const handleSelect = () => {
    if (selectedState) {
      alert(`You selected: ${selectedState.name}`);
    }
  };

  return (
    <div className="min-h-screen h-screen flex flex-col bg-white font-satoshi">
      {/* <div onClick={()=>navigate(-1)} 
      className=" top-2 left-2 text-black rounded-full p-2 cursor-pointer">
                          <ArrowLeft />
                          </div> */}
      <div className="flex-1 overflow-y-auto px-4 py-2 mb-[4rem]">
            <div
              style={{ borderBottom:'1px solid gray'}}
              className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
              onClick={()=>{navigate('/user-profile-details')}}

            >
             Personal Info
             <ChevronRight/>
            </div>
             <div
              style={{ borderBottom:'1px solid gray'}}
              className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
              onClick={()=>{navigate('/customer-activity')}}
            >
             
             Updates
             <ChevronRight/>

            </div>
            <div
              style={{ borderBottom:'1px solid gray'}}
              className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
              onClick={()=>{navigate('/invoices-for-customers')}}
            >
             
             Invoices
             <ChevronRight/>

            </div>
            <div
              style={{ borderBottom:'1px solid gray'}}
              className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
              onClick={()=>{navigate('/inspection-reports')}}
            >
             
             Inspection Reports
             <ChevronRight/>

            </div>
             {userId && userId.startsWith('VC-') && (
             <div
              style={{ borderBottom:'1px solid gray'}}
              className="flex items-center justify-between py-4 border-b cursor-pointer font-bold"
              onClick={()=>{navigate('/TDS-Application-page')}}
            >
             
             TDS
             <ChevronRight/>

            </div>
          )}
      </div>

      {/* Select Button */}
      <CurrentOrdersList/>
  
    <BottomNavigationCustomer/>
    </div>
  );
};

export default UserProfileSection;
